import localStorageService, { UNIDADE_LOGADA_KEY } from '../services/storage';

const getPaisAtuacao = async () => {
  const unidade = await localStorageService.get(UNIDADE_LOGADA_KEY);
  return unidade?.rede?.paisAtuacao || null;
}
export default getPaisAtuacao